import { videoModel } from "./defaults";

export const dop = videoModel("dop", "DoP", { start: 1 }, { image: "higgsfield-ai/dop/lite" });
